<template>
    <div class="Agenda">
        <div v-if="allStage">
            <div class="stage" :id="'go_'+stage.stage" :class="stage.stage" v-for="(stage, index0) in agendaList"
                :key="index0" data-aos="fade-up">
                <b-row class="info">
                    <b-col sm="12" align-self="end">
                        <strong class="time">{{stage.itemTime}}</strong>
                        <h2 class="title">{{$t(stage.stage)}}</h2>
                        <p class="stage-info">{{stage.info}}</p>
                        <!-- <a
                        :href="stage.youtube"
                        target="_blank"
                        class="mb-5 button"
                    >{{$t('directSeeding')}}</a> -->
                    </b-col>
                </b-row>
                <div class="tableaa" data-aos="fade-up">
                    <div>
                        <b-row class="activities" v-for="(activities, index1) in stage.activities" :key="index1">
                            <b-col>
                                <b-row class="activitiesItem"
                                    v-for="(activitiesItem, index2) in activities.activitiesItem" :key="index2"
                                    :id="stage.stage+'_'+index1+index2">
                                    <b-col sm="12" md="3">
                                        <span class="time">{{activitiesItem.starTime}} ~
                                            {{activitiesItem.endTime}}</span>
                                        <div v-if="activitiesItem.live">
                                            <span class="badge badge-danger">LIVE</span><br />
                                            <b-button variant="primary" size="sm" class="mb-3">進入議程</b-button>
                                        </div>
                                        <div v-if="activitiesItem.youtube">
                                            <b-button style="line-height:100%; margin-bottom:0.5rem"
                                                variant="outline-dark" :href="activitiesItem.youtube" target="_blank">
                                                <b-icon icon="camera-video"></b-icon>
                                            </b-button>
                                        </div>
                                        <div v-if="activitiesItem.youtube2">
                                            <b-button style="line-height:100%" variant="outline-dark"
                                                :href="activitiesItem.youtube2" target="_blank">
                                                <b-icon icon="camera-video"></b-icon>
                                            </b-button>
                                        </div>
                                        <div v-if="activitiesItem.pdf">
                                            <b-button style="line-height:100%" variant="outline-dark"
                                                :href="'/pdf/'+activitiesItem.pdf" target="_blank" download>
                                                <b-icon icon="file-earmark"></b-icon>
                                            </b-button>
                                        </div>
                                    </b-col>
                                    <b-col sm="12" md="9">
                                        <h5 class="title mb-3" v-if="activitiesItem.title">
                                            <span v-if="activitiesItem.end">{{activitiesItem.title}}</span>
                                            <b-link v-else v-on:click="setStage(stage.stage)" href="#"
                                                :to="{ name: 'Session', params: { stage:index0, activities:index1, activitiesItem:index2} }">
                                                {{activitiesItem.title}}</b-link>
                                        </h5>
                                        <ul class="list-unstyled" v-if="activitiesItem.speaker">
                                            <li v-for="(speaker, index3) in activitiesItem.speaker" :key="index3"
                                                v-bind:class="{ more: speaker.modal }">
                                                <div v-if="speaker.tag">
                                                    <b-badge variant="dark">{{speaker.tag}}</b-badge>
                                                </div>
                                                <div class="testapeaker">
                                                    <b-row v-if="speaker.modal" align-v="center"
                                                        :id="'speaker'+index0+index1+index2+index3"
                                                        @click="$bvModal.show('speaker'+index0+index1+index2+index3)">
                                                        <b-col cols="auto">
                                                            <b-img :src="require('../assets/img/speaker/'+speaker.img)"
                                                                class="img" fluid rounded="circle"></b-img>
                                                        </b-col>
                                                        <b-col>
                                                            <strong>{{speaker.name}}</strong>
                                                            <div v-html="speaker.career"></div>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row v-else align-v="center"
                                                        :id="'speaker'+index0+index1+index2+index3">
                                                        <b-col cols="auto">
                                                            <b-img :src="require('../assets/img/speaker/'+speaker.img)"
                                                                class="img" fluid rounded="circle"></b-img>
                                                        </b-col>
                                                        <b-col>
                                                            <strong>{{speaker.name}}</strong>
                                                            <div v-html="speaker.career"></div>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                                <b-modal :id="'speaker'+index0+index1+index2+index3"
                                                    footer-class="speaker-modal-footer" size="lg" centered title="講者"
                                                    ok-title="close" ok-only scrollable>
                                                    <div class="p-4">
                                                        <b-row>
                                                            <b-col cols="auto" class="text-center">
                                                                <b-img
                                                                    :src="require('../assets/img/speaker/'+speaker.img)"
                                                                    class="modal-img" fluid rounded="circle"></b-img>
                                                            </b-col>
                                                            <b-col>
                                                                <h4>{{speaker.name}}</h4>
                                                                <div class="mb-3" v-html="speaker.career"></div>
                                                                <div class="mb-3" v-html="speaker.positions"></div>
                                                                <div v-html="speaker.info"></div>
                                                            </b-col>
                                                        </b-row>
                                                    </div>
                                                </b-modal>

                                            </li>
                                        </ul>
                                    </b-col>
                                </b-row>
                                <div v-if="activities.host">
                                    <b-row>
                                        <b-col offset-md="3">
                                            <div v-if="activities.hostType">
                                                <b-badge variant="dark">{{activities.hostType}}</b-badge>
                                            </div>
                                            <div class="Moderator" @click="$bvModal.show('host_'+stage.stage+index1)">
                                                <b-row align-v="center">
                                                    <b-col cols="auto" class="text-center">
                                                        <b-img
                                                            :src="require('../assets/img/speaker/'+activities.hostImg)"
                                                            class="img" fluid rounded="circle"></b-img>
                                                    </b-col>
                                                    <b-col>
                                                        <strong>{{activities.host}}</strong>
                                                        <div v-html="activities.hostCareer"></div>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                            <b-modal :id="'host_'+stage.stage+index1"
                                                footer-class="speaker-modal-footer" size="lg" centered
                                                :title="activities.hostType" ok-title="close" ok-only scrollable>
                                                <div class="p-4">
                                                    <b-row>
                                                        <b-col cols="auto" class="text-center">
                                                            <b-img
                                                                :src="require('../assets/img/speaker/'+activities.hostImg)"
                                                                class="modal-img" fluid rounded="circle"></b-img>
                                                        </b-col>
                                                        <b-col>
                                                            <h4>{{activities.host}}</h4>
                                                            <div class="mb-3" v-html="activities.hostCareer"></div>
                                                            <div v-html="activities.hostInfo"></div>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                            </b-modal>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import agenda_en from "@/data/agenda_en";
    import agenda_tc from "@/data/agenda_tc";
    export default {
        name: "Agenda",
        data() {
            return {
                agendaList: null,
                allStage: true,
                singleSpeech: true,
            };
        },
        created() {
            this.setAgendaList();
        },
        mounted() {},
        methods: {
            // 記錄目前 Stage
            setStage: function (value) {
                this.$store.commit("setStage", value);
            },
            setAgendaList: function () {
                switch (localStorage.getItem("lang-mark")) {
                    case "tc":
                        this.agendaList = agenda_tc;
                        break;
                    case "en":
                        this.agendaList = agenda_en;
                        break;
                    default:
                        this.agendaList = agenda_en;
                        break;
                }
                //   if (localStorage.getItem("lang-mark") == "tc") {
                //     this.agendaList = agenda_tc;
                //   } else if (localStorage.getItem("lang-mark") == "en") {
                //     this.agendaList = agenda_en;
                //   }
            },
        },
        updated() {
            this.setAgendaList();
        },
    };
</script>